import EDC from '../../shared/globals';
import { AnswerMark } from '../../shared/mark-animation';

/**
 *
 */
EDC.Answer = function (scene, target, value) {
  this.scene = scene;
  this.value = value;
  this.target = target;
  this.container = null;
  this.bg = null;
  this.text = null;
  this.isInactive = false;
  this.clickTween = null;
  this.markAnim = null;
  this.slideDistance = 0;
  this.placeX = 0;
  this.isBusy = false;
  this.cursorManager = scene.cursorManager;
  this.strMapUnique = {
    10: 'ten',
    11: 'eleven',
    12: 'twelve',
    13: 'thirteen',
    14: 'fourteen',
    15: 'fifteen',
    16: 'sizteen',
    17: 'seventeen',
    18: 'eighteen',
    19: 'nineteen',
  };
  this.strMap = {
    1: {
      0: 'zero',
      1: 'one',
      2: 'two',
      3: 'three',
      4: 'four',
      5: 'five',
      6: 'six',
      7: 'seven',
      8: 'eight',
      9: 'nine',
      suffix: '',
      divider: 1,
    },
    2: {
      2: 'twenty',
      3: 'thirty',
      4: 'fourty',
      5: 'fifty',
      6: 'sixty',
      7: 'seventy',
      8: 'eighty',
      9: 'ninеty',
      suffix: '',
      divider: 10,
    },
    3: {
      suffix: 'hundred',
      divider: 100,
    },
    4: {
      suffix: 'thousand',
      divider: 1000,
    },
  };
};
/**
 *
 */
EDC.Answer.prototype.create = function () {
  this.container = this.scene.add.container(0, 0);

  this.bg = this.scene.add.sprite(0, 0, 'number-answer-bg');
  this.bg.setScale(1.05);

  this.container.add(this.bg);

  this.createText();

  this.markAnim = new AnswerMark(this.scene, this.container).setScale(0.45);

  const bounds = this.container.getBounds();
  this.container.setSize(bounds.width, bounds.height);
  this.container.setInteractive();
  this.container.on('pointerup', this.answerClick, this);

  this.cursorManager.setDefaultDraggableEvents(this.container);
};
/**
 *
 */
EDC.Answer.prototype.removeInteractive = function () {
  this.container.removeInteractive();
};
/**
 *
 */
EDC.Answer.prototype.changeValues = function (target, value) {
  this.target = target;
  this.value = value;
  this.bg.setTint(0xffffff);
  this.isInactive = false;
  this.markAnim.reset();
  this.text.text = this.getStringRepresentation();
  this.text.setColor('#000000');
  return this;
};
/**
 *
 */
EDC.Answer.prototype.answerClick = function () {
  if (this.isInactive) return;
  if (this.isBusy) return;
  if (this.clickTween && this.clickTween.isPlaying()) return;
  if (this.value === this.target) {
    this.scene.deactivateAnswers(this);
  }
  this.clickTween = this.scene.tweens.add({
    targets: this.container,
    scaleX: 0.9,
    scaleY: 0.9,
    ease: 'Linear',
    duration: 100,
    yoyo: true,
    onComplete: this.checkAnswer.bind(this),
  });
};
/**
 *
 */
EDC.Answer.prototype.checkAnswer = function () {
  if (this.isInactive) return;
  this.isInactive = true;
  if (this.value !== this.target) {
    this.text.setColor('#ff0000');
    this.bg.setTint(0xff0000);
    this.markAnim.showMark(false, () => {
      this.scene.playWrong();
    });
  } else {
    this.markAnim.showMark(true, () => {
      this.scene.correctAnswer();
    });
  }
};
/**
 *
 */
EDC.Answer.prototype.showMark = function (markSprite, completeCallback) {
  this.scene.tweens.add({
    targets: markSprite,
    scaleX: 1,
    scaleY: 1,
    duration: 800,
    ease: 'Bounce.easeOut',
    onComplete: function () {
      completeCallback();
    }.bind(this),
  });
};
/**
 *
 */
EDC.Answer.prototype.place = function (x, y, slide) {
  this.placeX = x;
  this.slideDistance = slide;
  this.container.setPosition(x + this.slideDistance, y);
  return this;
};
/**
 *
 */
EDC.Answer.prototype.appear = function () {
  this.isBusy = true;
  this.scene.tweens.add({
    targets: this.container,
    x: this.placeX,
    ease: 'Back.easeOut',
    easeParams: [0.8],
    duration: 750,
    onComplete: function () {
      this.isBusy = false;
    }.bind(this),
  });
};
/**
 *
 */
EDC.Answer.prototype.disappear = function () {
  this.isBusy = true;
  this.scene.tweens.add({
    targets: this.container,
    x: this.placeX + this.slideDistance,
    ease: 'Back.easeIn',
    easeParams: [0.8],
    duration: 750,
    onComplete: () => {
      this.isBusy = false;
      this.scene.answerDisappeared();
    },
  });
};
/**
 *
 */
EDC.Answer.prototype.getStringRepresentation = function () {
  let str = '';
  if (this.value === 0) {
    str = this.strMap['1']['0'];
  } else {
    str = this.getString(this.value);
  }
  return str.toUpperCase();
};
/**
 *
 */
EDC.Answer.prototype.createText = function () {
  this.text = this.scene.add.text(0, 0, this.getStringRepresentation(), {
    fontFamily: 'Arial',
    fontSize: '46px',
    fontStyle: 'bold',
    align: 'center',
    color: 'black',
    wordWrap: {
      width: (this.bg.displayWidth * 90) / 100,
    },
  });
  this.text.setLineSpacing(-10);
  this.text.setOrigin(0.5);
  this.container.add(this.text);
};
/**
 *
 */
EDC.Answer.prototype.getString = function (value) {
  let res = '';

  if (value > 0) {
    if (value >= 10 && value < 20) {
      res = this.strMapUnique[value.toString()];
    } else {
      const len = value.toString().length;
      const data = this.strMap[len.toString()];
      const suffix = data.suffix;
      const divider = data.divider;
      const leadDigit = Math.floor(value / divider);

      if (len > 2) {
        res = this.getString(leadDigit);
      } else {
        res = data[leadDigit.toString()];
      }

      const nextDigit = value % divider;
      res = `${res} ${suffix === '' ? '' : `${suffix} `}${this.getString(nextDigit)}`;
    }
  }

  return res;
};

export default EDC.Answer;
